var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitATicketSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 4.75H18V1.5C18 0.6875 17.3125 0 16.5 0H1.5C0.65625 0 0 0.6875 0 1.5V4.75H0.25C0.9375 4.75 1.5 5.3125 1.5 6C1.5 6.71875 0.9375 7.25 0.25 7.25H0V10.5C0 11.3438 0.65625 12 1.5 12H16.5C17.3125 12 18 11.3438 18 10.5V7.25H17.75C17.0312 7.25 16.5 6.71875 16.5 6C16.5 5.3125 17.0312 4.75 17.75 4.75ZM16.5 3.5625C15.5938 4.03125 15 4.9375 15 6C15 7.09375 15.5938 8 16.5 8.46875V10.5H1.5V8.46875C2.375 8 3 7.09375 3 6C3 4.9375 2.375 4.03125 1.5 3.5625V1.5H16.5V3.5625Z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitATicketSmall);
export default __webpack_public_path__ + "static/media/submit-a-ticket-small.cf361c2ea60977d0e467f0a7a1a3b285.svg";
export { ForwardRef as ReactComponent };